import { Controller } from "@hotwired/stimulus";
import { alert } from "notie";

export default class extends Controller {
  close() {
    this.element.remove();
  }
}
